import {ResponsiveSankey} from "@nivo/sankey";

const testPositivityData = {
    "nodes": [
        {
            "id": "Uninfected",
            // "color": "#000000"
        },
        {
            "id": "Infected",
            // "color": "#000000"
        },
        {
            "id": 'Untested',
            // "color": "#5c5c5c"
        },
        // {
        //     "id": "Diagnosed",
        //     "color": "#f8a8a8"
        // },
        {
            "id": "Home-tested",
            // "color": "#000000"
        },
        {
            "id": "Lab-tested",
            // "color": "#000000"
        },
        {
            "id": "Negative",
            // "color": "#000000"
        },
        {
            "id": "Positive",
            // "color": "#000000"
        },
        // {
        //     "id": "Positivity Ratio",
        //     "color": "#000000"
        // }
    ],
    "links": [
        {
            "source": "Uninfected",
            "target": "Home-tested",
            "value": 20
        },
        {
            "source": "Uninfected",
            "target": "Lab-tested",
            "value": 70
        },
        {
            "source": "Uninfected",
            "target": 'Untested',
            "value": 60
        },
        {
            "source": "Infected",
            "target": 'Untested',
            "value": 10
        },
        // {
        //     "source": "Infected",
        //     "target": "Diagnosed",
        //     "value": 80
        // },
        {
            // "source": "Diagnosed",
            "source": "Infected",
            "target": "Home-tested",
            "value": 10
        },
        {
            // "source": "Diagnosed",
            "source": "Infected",
            "target": "Lab-tested",
            "value": 20
        },
        {
            "source": "Lab-tested",
            "target": "Negative",
            "value": 70
        },
        {
            "source": "Lab-tested",
            "target": "Positive",
            "value": 20
        },
        // {
        //     "source": "Negative",
        //     "target": "Positivity Ratio",
        //     "value":50
        // },
        // {
        //     "source": "Positive",
        //     "target": "Positivity Ratio",
        //     "value":20
        // }
    ]
};

const TestPositivitySankey = () => (
    <ResponsiveSankey
        data={testPositivityData}
        margin={{top: 10, right: 50, bottom: 40, left: 60}}
        align="start"
        // sort="descending"
        colors={{scheme: 'category10'}}
        nodeOpacity={1}
        nodeThickness={18}
        nodeInnerPadding={3}
        nodeSpacing={24}
        nodeBorderWidth={0}
        nodeBorderColor={{from: 'color', modifiers: [['darker', 0.8]]}}
        linkOpacity={0.5}
        linkHoverOthersOpacity={0.1}
        enableLinkGradient={true}
        labelPosition="inside"
        // labelOrientation="vertical"
        labelPadding={6}
        labelTextColor={{from: 'color', modifiers: [['darker', 1]]}}
        isInteractive={false}
    />
)

export default TestPositivitySankey;